<template>
  <div class="c-selecter">
    <el-row>
      <el-col ref="bar" :span="maxCol" class="c-select-box">
        <el-row class="c-select-flex">
          <el-col :span="24" class="c-selecter-item">
            <select-item
              :title="title"
              :disabled="disabled"
              :search="search"
              :gameGroupData="gameGroupData"
              :midGameData="midGameData"
              :visible="visible"
              @on-search="queryGame"
            >
              <select-box
                :data="data"
                :filter="filter"
                :disabled="disabled"
                :enable-select-all="enableSelectAll"
                :no-select-all="noSelectAll"
                @on-checked="handleCheck"
                @on-select="selectAll"
              />
            </select-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="7" :offset="1">
        <select-item v-if="transfer" :title="resultTitle" :search="search" clear @on-clear="$emit('on-clear', { list: data })">
          <div v-for="item in result" :key="item.id" class="c-pop-tip">
            <el-tag :key="item.value" closable class="c-tag-item" @close="handleClose($event, item.value)">
              <span :title="item.value">{{ item.value }}</span>
            </el-tag>
          </div>
        </select-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import SelectItem from './select-item.vue'
import SelectBox from './select-box.vue'
export default {
  name: 'selectAccount',
  components: { SelectItem, SelectBox },
  props: {
    value: {
      type: Array
    },
    title: {
      type: String
    },
    data: {
      type: Array
    },
    transfer: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    resourceTitle: {
      type: Boolean
    },
    search: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number
    },
    enableSelectAll: {
      type: Boolean,
      default: false
    },
    noSelectAll: {
      type: Boolean
    },
    gameGroupData: {
      type: Array
    },
    midGameData: {
      type: Array
    },
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      resource: [],
      filter: {}
    }
  },
  computed: {
    maxCol() {
      return this.transfer ? 16 : 24
    },
    result() {
      return this.value
    },
    resultLen() {
      return Boolean(this.value.length)
    },
    resultTitle() {
      return `已选${this.resultLen ? '(' + this.value.length + (this.max ? `/${this.max}` : '') + ')' : ''}`
    }
  },
  methods: {
    handleClose(event, name) {
      this.$emit('on-delete', { list: this.data, name })
    },
    // 单个选项已完成改变
    handleCheck(params) {
      this.$emit('on-checked', params)
    },
    selectAll({ filterResult, check, key }) {
      let id = 0
      key && (id = key)
      // const num = this.data.map(ret => ret.check).length
      this.$emit('on-select', {
        check,
        id,
        list: filterResult
      })
      this.$emit('on-checked', {
        key,
        check
      })
    },
    queryGame(info) {
      this.filter = info
    }
  }
}
</script>
<style lang="scss" scoped>
.c-selecter {
  position: relative;

  .c-select-box {
    border: solid 1px #dee4f5;
    overflow-x: auto;

    .c-select-flex {
      display: flex;
      flex-wrap: nowrap;

      .c-selecter-item {
        min-width: 200px;
        display: inline-block;
        border-left: solid 1px #dee4f5;

        &:first-child {
          border-left: none;
        }
      }
    }
  }

  .c-pop-tip {
    width: 100%;
  }

  .c-tag-item {
    width: 90%;
    margin: 8px 8px 0;
    padding: 2px 6px;
    display: block;
    font-size: 14px;
    height: 28px;

    > span {
      width: 85%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
    }

    ::v-deep .el-tag__content {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 90%;
      display: inline-block;
    }
  }
}

::v-deep .el-tag {
  .el-tag__close {
    top: 3px;
    float: right;
  }

  ::v-deep .el-checkbox-group {
    .el-checkbox {
      margin-right: 0;
    }
  }
}
</style>
